/**
 * Giftbox app checkout button fix.
 *
 * The Giftbox app clones #checkout and hides the original with inline styles.
 * After a cart section morph (quantity change), the clone is removed but the
 * app re-hides the original without re-cloning — leaving no visible button.
 *
 * Fix: after morph settles, if the button is hidden and no clone exists,
 * create a visible clone ourselves (mimicking what Giftbox should have done).
 */

/** @typedef {{ cloneButtons: () => void, updateObservers: () => void, drawerCallback: () => void, customButtonSelectors: string[] }} GiftBoxAPI */
/** @type {GiftBoxAPI | undefined} */
// @ts-ignore — injected by Giftbox app via content_for_header
const GiftBox = /** @type {any} */ (window).GiftBox;

const OBSERVER_CONFIG = { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] };

let timeout = 0;
let fixed = false;

/** @param {HTMLElement} btn */
function cloneCheckoutButton(btn) {
  const clone = /** @type {HTMLElement} */ (btn.cloneNode(true));
  clone.removeAttribute('style');
  clone.removeAttribute('id');
  clone.classList.add('giftbox-checkout-cloned');
  btn.after(clone);
}

function fix() {
  if (fixed) return;
  const btn = document.getElementById('checkout');
  if (!btn) return;

  const isHidden = btn.hasAttribute('style') && getComputedStyle(btn).display === 'none';
  if (isHidden && !document.querySelector('.giftbox-checkout-cloned')) {
    fixed = true;
    observer.disconnect();
    cloneCheckoutButton(btn);
    GiftBox?.cloneButtons();
  }
}

const observer = new MutationObserver(() => {
  cancelAnimationFrame(timeout);
  timeout = requestAnimationFrame(() => fix());
});

function arm() {
  fixed = false;
  cancelAnimationFrame(timeout);
  const target = document.querySelector('.cart__ctas');
  if (!target) return;
  observer.disconnect();
  observer.observe(target, OBSERVER_CONFIG);
}

document.addEventListener('cart:update', arm);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', arm);
} else {
  arm();
}
